import * as types from '../constants/ActionTypes'
const _ = require('lodash')

const initalState = {
  selectData: {},
  count: [],
  form: [],
  page: [],
  list: [],
  tmpForm: [],
}

const createNewState = (state, action, sname, pname) => {
  let newData = state[sname]
  newData[action.payload.masterType] = action.payload[pname]
  return newData
}

const master = (state = initalState, action) => {
  
  switch (action.type) {
    case types.REDUCER_MASTER_SET_CLICK_KIND:
    case types.REDUCER_MASTER_SET_SELECT_DATA:
      return Object.assign({}, state, action.payload)
    case types.REDUCER_MASTER_SET_LIST:

      const form = createNewState(state, action, 'form', 'form')
      const list = createNewState(state, action, 'list', 'list')
      const count = createNewState(state, action, 'count', 'count')
      const page = createNewState(state, action, 'page', 'page')
      const tmpForm = createNewState(state, action, 'tmpForm', 'form')

      return Object.assign({}, state,
        {...action.payload,
          list: list,
          count: count,
          form: form,
          page: page,
          tmpForm: tmpForm,
        })

    case types.REDUCER_MASTER_FORM_RESET:
      //const newForm = Object.assign({}, state.form, {id: ''})

      let clearForm = state.form;
      clearForm[action.payload.masterType] = {}

      return Object.assign({}, state,
        {
          form: clearForm,
        }
      )
    case types.REDUCER_MASTER_SET_FORM:
      const newForm = createNewState(state, action, 'form', 'form')

      return Object.assign({}, state,
        {
          form: newForm,
        }
      )

    case types.REDUCER_MASTER_INIT:
      return Object.assign({}, state, {selectData: {}})
    default:
      return state
  }
}

export default master


// WEBPACK FOOTER //
// ./src/reducers/master.js